import VSpace from "../components/common/VSpace"
import RouteSettings from "../components/settings/routes/RouteSettings"

const RouteSettingsPage = () => {
  return <div style={{backgroundColor: 'white'}}>
    <VSpace>
      <div style={{fontSize: '24px', fontWeight: 'bold', padding: '20px'}}>Route Settings</div>
    </VSpace>
    <VSpace size="large" style={{ background: '#f6f6f6 url("/images/greyzz.png") repeat' }}>
      <RouteSettings />
    </VSpace>
  </div>
}

export default RouteSettingsPage
